// extracted by mini-css-extract-plugin
export default {"editProfile":"style_editProfile__HY93o","header":"style_header__hQrxa","actions":"style_actions__7IbRE","content":"style_content__nRTa+"};